var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"disabled":_vm.disabled,"size":"small","type":"textarea","rows":2},on:{"change":_vm.onCommentChange},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})}
var staticRenderFns = []

export { render, staticRenderFns }